var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.value)?_c('b-badge',{staticClass:"w-75 size",attrs:{"variant":_vm.sizeIndicator(_vm.value)}},[_vm._v(_vm._s(_vm.formatBytes(_vm.value))+"\n  ")]):_c('span',[_vm._v("N/A")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }